/**
 * Personnel UI State
 * Data now comes from RTK Query (personnelApi), not Redux state.
 * This slice manages UI state only: search, modal, selection.
 */
export interface PersonnelState {
  searchTerm: string;
  isModalOpen: boolean;
  selectedPersonnelId: string | null;
  modalMode: 'add' | 'edit';
  sortField: 'name' | 'updated_at';
  sortOrder: 'asc' | 'desc';
}

export const initialPersonnelState: PersonnelState = {
  searchTerm: '',
  isModalOpen: false,
  selectedPersonnelId: null,
  modalMode: 'add',
  sortField: 'updated_at',
  sortOrder: 'desc',
};
